import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto es solo teoría?',
    a: 'No. Es práctico: ejercicios diarios, checklists, plan 7 días y guías.'
  }, {
    q: '¿Cuándo empiezo a notar cambios?',
    a: 'Muchos notan más calma y claridad en la primera semana. Lo sólido se construye practicando.'
  }, {
    q: '¿Sirve si soy tímido o introvertido?',
    a: 'Sí. Está hecho para construir seguridad con estructura, no para ser extrovertido.'
  }, {
    q: '¿Esto enseña manipulación?',
    a: 'No. Enseña presencia, límites, comunicación y respeto.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Te llega el acceso/descarga al correo inmediatamente después del pago.'
  }];
  return <section className="py-24 px-4 bg-bg-primary" data-id="element-13">
      <div className="container max-w-3xl mx-auto" data-id="element-14">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-heading font-bold text-text-primary text-center mb-12" data-id="element-15">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-17" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="border border-border-color rounded-xl bg-bg-card overflow-hidden" data-id="element-18">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-19">
        <span className="font-bold text-text-primary text-lg" data-id="element-20">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-cta-primary" data-id="element-21" /> : <ChevronDown className="w-5 h-5 text-text-secondary" data-id="element-22" />}
      </button>

      <AnimatePresence data-id="element-23">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-24">
            <div className="px-6 pb-6 text-text-secondary leading-relaxed border-t border-border-color/50 pt-4" data-id="element-25">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}